import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import { SectionCard, ui } from '../shared/insightUi';

const pillStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '7px 14px',
  borderRadius: 999,
  background: '#F0FDF4',
  color: '#15803D',
  fontSize: 13,
  fontWeight: 700,
  fontFamily: ui.font,
};

export default function RelevantHashTags({ relevant_tags = [] }) {
  const tags = (Array.isArray(relevant_tags) ? relevant_tags : []).slice(0, 12);
  if (!tags.length) return null;
  return (
    <SectionCard
      icon={<LocalOfferRoundedIcon fontSize="small" />}
      title="Relevant hashtags"
      subtitle="Hashtags relevant to this creator's niche"
    >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        {tags.map((hashtag, i) => (
          <span style={pillStyle} key={i}>
            #{hashtag.tag}
          </span>
        ))}
      </div>
    </SectionCard>
  );
}
